/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request body for updating a webhook feature configuration
 * @export
 * @interface UpdateTenantWebhookFeature
 */
export interface UpdateTenantWebhookFeature {
    /**
     * The webhook type identifier
     * @type {string}
     * @memberof UpdateTenantWebhookFeature
     */
    webhookType: string;
    /**
     * Whether this webhook type is enabled for the tenant
     * @type {boolean}
     * @memberof UpdateTenantWebhookFeature
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the UpdateTenantWebhookFeature interface.
 */
export function instanceOfUpdateTenantWebhookFeature(value: object): value is UpdateTenantWebhookFeature {
    if (!('webhookType' in value) || value['webhookType'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function UpdateTenantWebhookFeatureFromJSON(json: any): UpdateTenantWebhookFeature {
    return UpdateTenantWebhookFeatureFromJSONTyped(json, false);
}

export function UpdateTenantWebhookFeatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTenantWebhookFeature {
    if (json == null) {
        return json;
    }
    return {
        
        'webhookType': json['webhook_type'],
        'enabled': json['enabled'],
    };
}

export function UpdateTenantWebhookFeatureToJSON(json: any): UpdateTenantWebhookFeature {
    return UpdateTenantWebhookFeatureToJSONTyped(json, false);
}

export function UpdateTenantWebhookFeatureToJSONTyped(value?: UpdateTenantWebhookFeature | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'webhook_type': value['webhookType'],
        'enabled': value['enabled'],
    };
}

